<template>
  <div class="v-view table-view a-fadeIn JSNumber">
    <div class="v-title">{{ title }}</div>
    <div class="JSN-content">
      <!-- <div>
        <p>198次</p>
        <p>城区</p>
      </div>
      <div>
        <p>57次</p>
        <p>沁水县</p>
      </div>
      <div>
        <p>39次</p>
        <p>阳城县</p>
      </div>
      <div>
        <p>22次</p>
        <p>陵川县</p>
      </div>
      <div>
        <p>73次</p>
        <p>泽州县</p>
      </div>
      <div>
        <p>98次</p>
        <p>高平市</p>
      </div> -->
      <div v-for="(item,key) in number" :key="key">
        <p>{{item.total}}次</p>
        <p>{{item.agedLiveCounty}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { numToThousands } from '@/utils';

export default {
  name: 'JCNumber',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '各区县报警人次',
    },
  },
  watch: {
  },
  data() {
    return {
      number:[]
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    let that = this;
    this.dataInterval = setInterval(() => {
      // this.getServiceDynamicData(this.cid)
      that.getData();
    }, this.$interval);
  },
  beforeDestroy() {},
  methods: {
    getData(){
      this.$api.CountDeviceTimes().then((result) => {
        if (!result || result.length == 0) return
        this.number = result
      }).catch((err) => {
        console.log(err);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.JSNumber{
  width: calc(100% - 1100px);
  height: 29.16375vh;
  position: absolute;
  left: 550px;
  bottom: 43px;
}
.JSN-content{
  
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  div{
    background: url('../assets/images/jc/alermBG.png') no-repeat center/102px 13.426vh;
    width: 102px;
    height: 13.426vh;
    p{
      text-align: center;
      background: -webkit-linear-gradient(#ffa8a7, #fff6f6);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      
    }
    p:first-child{
      padding-top: 3.7vh;
      font-size: 18px;
      font-family: "pmzd";
    }
    p:last-child{
      padding-top: 4.5vh;
      font-size: 20px;
    }
  }
}
</style>
